import { InjectionToken } from '@angular/core';
export const NAVIGATION_OPTIONS = new InjectionToken<boolean>('NavigationOptions');

export interface NavigationOptions {
  production: boolean;
}
